import { CircularProgress, Box, circularProgressClasses } from "@mui/material";

export default function CustomSpinner() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                width: '100%',
                position: 'fixed',
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <CircularProgress
                    variant="determinate"
                    sx={(theme) => ({
                        color: theme.palette.grey[200],
                    })}
                    size={60}
                    thickness={4}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    sx={() => ({
                        color: 'piction.highlight',
                        animationDuration: '550ms',
                        position: 'absolute',
                        left: 0,
                        [`& .${circularProgressClasses.circle}`]: {
                            strokeLinecap: 'round',
                        },
                    })}
                    size={60}
                    thickness={4}
                />
            </Box>
        </Box>
    );
};
